export const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
export const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
export const windowHeight = window.innerHeight;
export const header = document.querySelector('.header');
